import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'

import {
  hideGenericMessage
} from '../../store/app/actions'

class GenericMessage extends Component {
  static propTypes = {
    genericMessage: PropTypes.shape({
      visible: PropTypes.bool,
      message: PropTypes.string
    }).isRequired,
    hideGenericMessage: PropTypes.func.isRequired
  }

  render () {
    const { visible, message } = this.props.genericMessage

    return (
      <Snackbar
        open={visible}
        message={message}
        autoHideDuration={3500}
        onClose={this.props.hideGenericMessage}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  genericMessage: state.app.genericMessage
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      hideGenericMessage
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(GenericMessage)
